import React from 'react';
import { hasValue, isTruthy } from 'utility/functions';

import { AmbienteContext } from 'context/Ambiente';
import { Carousel } from 'components/carousel';
import { SportQuickLinkCard } from 'features/sport/components/sportQuickLinkCard';
import { SportsCacheTopManifestazioneDto } from 'types/swagger';
import { Wrapper } from 'components/wrapper';
import { selectIsTop } from 'features/sport/selectors';
import styles from './SportTopManifestazioni.module.scss';
import { useDynamicTempate } from 'features/sport/hooks';
import { useRouter } from 'next/router';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type SportTopManifestazioniProps = {
  title: string;
  className: string;
};

const MySportTopManifestazioni = ({ title, className }: SportTopManifestazioniProps) => {
  const { slug, template: listItem } = useDynamicTempate<Array<SportsCacheTopManifestazioneDto>>();
  const { isMobile } = useWindowSize();
  const isTop = useTypedSelector(selectIsTop);
  const items = (listItem ?? []).filter(
    (item, idx, lst) => hasValue(item.slug) && lst.findIndex((x) => x.slug === item.slug) === idx
  );

  if (items?.length < listItem?.length) {
    console.log(`WARNING: top-manifestazioni: ${listItem.length - items.length} manifestazione excluded`);
  }

  if (!isTruthy(items.length)) {
    return <React.Fragment key={'sport-top-manifestazioni'} />;
  }

  return (
    <Wrapper
      key={`Sport-Top-Manifestazioni-${slug}-${(items ?? []).length}`}
      bgColorTransparent
      noPaddingLeft={isMobile}
      noPaddingRight
      className={className}
    >
      <Carousel
        title={title}
        hasNoLeftPadding={isMobile}
        cardContainerClassName={styles.topManifestazioniCardContainer}
      >
        {items
          .filter((x, idx, lst) => lst.findIndex((y) => y.slug === x.slug) === idx)
          .map((item, idx) => (
            <SportQuickLinkCard key={`${slug}-${item.slug}.${idx}`} {...item} isTop={isTop} />
          ))}
      </Carousel>
    </Wrapper>
  );
};

export const SportTopManifestazioni = (props: SportTopManifestazioniProps) => {
  const { isReady, isFallback, asPath } = useRouter();

  return (
    <AmbienteContext.Provider
      key={`content-next-events`}
      value={{
        ambiente: 'sport',
        pathScommessa: ['sport', 'topManifestazioni', 'scommesse'],
      }}
    >
      <MySportTopManifestazioni {...props} key={`MySportTopManifestazioni-${isReady}-${isFallback}-${asPath}`} />
    </AmbienteContext.Provider>
  );
};